import { ReactElement } from 'react';
import { ModalTarget, ModalWorksheetArticleVariantProps, SharedModalProps } from 'types/Modal';
import { InstantSearch } from 'react-instantsearch';
import { ALGOLIA_INDEX_NAME } from 'config/env';
import { searchClient } from 'utils/algoliaSearchClient';
import { useBreakpoint } from 'hooks/utils/layout/useBreakpoint';
import { Breakpoints } from 'types/breakpoints';
import { CustomModal } from '../../CustomModal';
import { ModalNavigationProvider } from './components/ModalNavigationContext';
import { ArticleModalContent } from './components/articleModal/ArticleModalContent';
import { ArticleModalProvider } from './components/articleModal/ArticleModalContext';

type Props = SharedModalProps & ModalWorksheetArticleVariantProps;

export const WorksheetArticleModal = ({ handleClose, isShown, onSelect }: Props): ReactElement => {
  const isDesktop = useBreakpoint(Breakpoints.DESKTOP);
  const target = isDesktop ? ModalTarget.PAGE_DESKTOP : ModalTarget.PAGE_MOBILE;

  const submitSelection = (data: {
    title: string;
    description?: string;
    thumbnailUrl?: string;
  }): void => {
    if (onSelect) {
      // onSelect(data);
    }
    handleClose();
  };

  return (
    <InstantSearch indexName={ALGOLIA_INDEX_NAME} searchClient={searchClient}>
      <ModalNavigationProvider>
        <ArticleModalProvider submitSelection={submitSelection}>
          <CustomModal
            isOpen={isShown}
            placement="center"
            onClose={handleClose}
            title="Lernkarte einfügen"
            shouldAlwaysStretchHeight
            hideHeader
            target={target}
          >
            <ArticleModalContent handleClose={handleClose} />
          </CustomModal>
        </ArticleModalProvider>
      </ModalNavigationProvider>
    </InstantSearch>
  );
};
